import { render, staticRenderFns } from "./AddToFavoriteModal.vue?vue&type=template&id=593662d7"
import script from "./AddToFavoriteModal.vue?vue&type=script&lang=js"
export * from "./AddToFavoriteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports